import(/* webpackMode: "eager" */ "/app/app/(app)/settings/page.tsx");
